import React from 'react'
import PropTypes from 'prop-types'
import { Divider, Grid, Typography } from '@mui/material'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
import { Title } from '../StyledElements'

const EmptyLine = ({ styleProps }) => (
  <Divider
    style={{
      padding: '16px 0px 0px 0px',
      margin: '0px 16px 0px 0px',
      flex: 1,
      ...styleProps,
    }}
  />
)

const SignatureDateLine = ({ hideDate, date }) => (
  <Grid container>
    {hideDate ? (
      <>
        <Grid item xs={4} mt={4}>
          <Typography variant="body2" ml={2}>
            Signature
          </Typography>
          <EmptyLine styleProps={{ margin: '0px 16px 16px 0px' }} />
        </Grid>
      </>
    ) : (
      <>
        <Grid item xs={6} mt={date ? 4.5 : 4}>
          <EmptyLine />
          <Typography>Signature</Typography>
        </Grid>

        <Grid item xs={6} mt={date ? 0.5 : 4}>
          {date && <Title>{dateFormatter(date)}</Title>}
          <EmptyLine />
          <Typography>Date</Typography>
        </Grid>
      </>
    )}
  </Grid>
)

SignatureDateLine.propTypes = {
  hideDate: PropTypes.bool,
  date: PropTypes.number, // milliseconds
}

SignatureDateLine.defaultProps = {
  hideDate: false,
  date: null,
}

EmptyLine.propTypes = {
  styleProps: PropTypes.object,
}

EmptyLine.defaultProps = {
  styleProps: {},
}

export default SignatureDateLine
